import { Component, ViewChild } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { AdminsService } from 'src/app/_services/admins/admins.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {
  home: MenuItem | undefined;
  @ViewChild('closebutton') closebutton: any;

  showSide: string = '';
  products!: Array<object>;
  selectedProducts: Array<object> = [];
  headerData: Array<any> = [];
  subscriptions:Subscription[] = [];
  loading: boolean = true;
  monthButton  : boolean= true;
  weekButton  : boolean= false;
  userId:any;
  // search: boolean = false;
  listDropDown: Array<object> = [{ name: 'All  ' },
    { name: 'Today' },
    { name: 'Last Week' },
    { name: 'This month' },
    { name: 'This year' },
  ];
private routeSubscription!:Subscription;
private allowedRoutes: string[] = [
  '/users/app-edite-user-details/',
  '/users'
];
private storageRemoved = false;
  constructor(
    public _adminservices: AdminsService,
    private messageService: MessageService,
    public router: Router
  ) {
    this.routeSubscription=this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        // if (!event.url.startsWith('/users/app-edite-user-details/')){
        //   console.log("Navigating away from /user-details. Clearing localStorage...");
        //   localStorage.removeItem('pageNoUsers');
        // }
 ///////////////////////////////////////////////////////////////
        //  let currentRoute = event.urlAfterRedirects.replace(/^#/, '');
 
        //  if (!currentRoute.startsWith('/users/app-edite-user-details/')) {
        //    console.log("Navigating away from /users/app-edite-user-details/:id. Clearing localStorage...");
        //    localStorage.removeItem('pageNoUsers');  
        //  }
        //  if (!currentRoute.startsWith('/users')) {
        //   console.log("Navigating away from /users. Clearing localStorage...");
        //   localStorage.removeItem('pageNoUsers');  
        // }
           
        let currentRoute = event.urlAfterRedirects.replace(/^#/, '');

        console.log("🔍 Current Route:", currentRoute);
        console.log("🚀 Checking if storage should be removed...");

        // ✅ Keep LocalStorage when on "/users" or "/users/app-edite-user-details/:id"
        if (
          currentRoute === '/users' || 
          /^\/users\/app-edite-user-details\/[a-zA-Z0-9-]+$/.test(currentRoute)
        ) {
          console.log("✅ Allowed route detected. Keeping LocalStorage.");
          this.storageRemoved = false; // Reset when returning to an allowed route
        } 
        // ❌ Remove LocalStorage only the first time leaving the allowed routes
        else if (!this.storageRemoved) {
          console.log("🚨 Leaving allowed routes for the first time. Removing LocalStorage...");
          localStorage.removeItem('pageNoUsers');
          this.storageRemoved = true; // Prevent removing again when returning
        } else {
          console.log("🔵 Already left allowed route before, no need to remove again.");
        }
      }
    })
  }
  currentPage: number = 0;
  @ViewChild('dt2', { static: false }) dt2?: any;
  tableReady = false;

  onPageChange(event: any) {
    this.currentPage = event.first;
    console.log(this.currentPage)
    localStorage.setItem('userPage', this.currentPage.toString());
  }


  ngOnInit() {
    const savedPage = localStorage.getItem('userPage');
    this.currentPage = savedPage ? +savedPage : 0;
    console.log(this.currentPage)

    this.home = { icon: 'pi pi-home', routerLink: ['/dashboard'] };

    // this.getAllTenants();
    this.checkRole();
    if(localStorage.getItem('pageNoUsers')){
      let number=Number(localStorage.getItem('pageNoUsers'))
      let numberF=Number(localStorage.getItem('first'))

      let numberR=Number(localStorage.getItem('rows'))

      this.pageNumber=number
      this.first=numberF
      this.rows=numberR
    this.getAllTenants();

      
    }else{
    this.getAllTenants();

    }
  }
  TantsRole: any;
  is_Super: any;
  checkRole() {
    const data = localStorage.getItem('user');
    if (data !== null) {
      let parsedData = JSON.parse(data);
      this.is_Super = parsedData.is_Super;
      if (parsedData.is_Super == false) {
        for (let i = 0; i < parsedData.permissions.length; i++) {
          if (parsedData.permissions[i].page_Name == 'Users') {
            this.TantsRole = parsedData.permissions[i];
          }
        }
        if (this.TantsRole.p_View == false && this.is_Super == false) {
          this.gotopage();
        }
      }
    }
  }
  gotopage() {
    let url: string = 'unlegal';
    this.router.navigateByUrl(url);
  }
  /**
   * selectedfromDropDown
   * @param $event string
   * @returns void
   */
  selectedfromDropDown(value: any) {
    this.Date = value.name;
    this.getAllTenants();
  }
  /**
   * addItem
   * @param value string
   * @returns void
   */
  addItem(value: string): void {
    this.showSide = value;
  }

  statusTenant: any = '';
  pageNumber = 1;
  pagesize = 10;
  totalofPages = 0;
  disablenext = false;
  disableperv = false;
  first: number = 1;
  rows: number = 10;

  Tenants = [];
  numberTenants = 0;
  totalRecords = 0;
  Date: any = 'All';
  getAllTenants() {
    this.Tenants = [];
    this.numberTenants = 0;
    this.subscriptions.push( this._adminservices
      .TenantList(this.pageNumber, 20000 , this.Date, this.searchText)//this.pagesize
      .subscribe(
        (res: any) => {
          console.log(res)
          this.Tenants = res['data'];
          // this.numberTenants = this.Tenants.length;
           

          this.totalofPages = res['totalPages'];
          this.totalRecords = res['totalRecords'];
          this.numberTenants = this.totalRecords;
/////////////////////////////////////////////////////
          const savedPage = localStorage.getItem('userPage');
          this.currentPage = savedPage ? +savedPage : 0;
          console.log(this.currentPage) 
          this.tableReady = true;
////////////////////////////////////////////////////

          if (this.totalofPages == this.pageNumber) {
            this.disablenext = true;
          } else {
            this.disablenext = false;
          }
          if (this.pageNumber == 1) {
            this.disableperv = true;
          } else {
            this.disableperv = false;
          }
        
        },
        (error) => {
          console.error('Error fetching owners:', error);
        }
      ));

  }

  parseDateString(dateStr: string): Date {
    const [datePart, timePart, ampm] = dateStr.split(' '); // "05-01-2025", "11:19", "AM"
    const [day, month, year] = datePart.split('-');
    let [hour, minute] = timePart.split(':');
  
    // لو الوقت "PM" و أقل من 12 بنزوده 12 ساعة
    if (ampm === 'PM' && +hour < 12) {
      hour = (parseInt(hour) + 12).toString();
    }
  
    // لو الوقت "AM" و الساعة 12، نرجعه لـ 0
    if (ampm === 'AM' && +hour === 12) {
      hour = '0';
    }
  
    const formatted = `${year}-${month}-${day}T${hour.padStart(2, '0')}:${minute}:00`;
  
    return new Date(formatted);
  }
  
  tiggerPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    let calcPageNumber = Math.floor(this.first / this.rows) + 1;
    this.pageNumber = calcPageNumber;
    this.getAllTenants();
    localStorage.setItem('pageNoUsers',this.pageNumber.toString())
    localStorage.setItem('first',this.first.toString())

    localStorage.setItem('rows',this.rows.toString())

  }
  FilterButtons(value:any){
    this.Date=value;
    if(this.Date == 'This Month'){
      this.monthButton = true;
      this.weekButton = false
    }else{
      this.monthButton = false;
      this.weekButton = true;
    }
    this.getAllTenants()
  }
  DeleteUser() {
    this.subscriptions.push(this._adminservices.DeleteTenant(this.userId).subscribe(
      (res: any) => {
        this.closebutton.nativeElement.click();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `${res.message}`,
        });

        this.getAllTenants();
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error.error.message[0]}`,
        });
      }
    ));

  }
  SuspendUser() {
    this.subscriptions.push( this._adminservices.SuspendTenant(this.userId).subscribe(
      (res: any) => {
        this.closebutton.nativeElement.click();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `${res.message}`,
        });

        this.getAllTenants();
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error.error.message[0]}`,
        });
      }
    ));
  }
  unSuspendUser() {
    this.subscriptions.push(  this._adminservices.UnSuspendTenant(this.userId).subscribe(
      (res: any) => {
        this.closebutton.nativeElement.click();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `${res.message}`,
        });

        this.getAllTenants();
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error.error.message[0]}`,
        });
      }
    ));
  }
  detailperson(event: any, id: any): void {
    this.showEdit = [];
    event.stopPropagation();

    this.showEdit[id] == true
      ? (this.showEdit[id] = false)
      : (this.showEdit[id] = true);
  }

  globalFilter: string = '';


  showEdit: Array<boolean> = [];
  hidecard(id: any) {
    this.showEdit = [];
  }
  searchText: any = '';

  searchKey(data: string) {
    this.searchText = data;
    this.getAllTenants();
  }
  searchTextChange: any;
  searchAction(event: KeyboardEvent) {
    if (this.searchText.trim() === '' && (event.key === 'Backspace' || event.key === ' ')) {
      event.preventDefault();
      return;
  }
    this.getAllTenants();
  }


  display = 'none';
  model1: Boolean = false;
  model2: Boolean = false;
  model3: Boolean = false;
  deleteModal(id: any) {
    this.display = 'block';
    this.display = 'flex';
    this.model1 = true;
    this.model2 = false;
    this.model3 = false;
    this.userId = id;
  }
  SuspendModal(id: any) {
    this.display = 'block';
    this.display = 'flex';
    this.model2 = true;
    this.model1 = false;
    this.model3 = false;
    this.userId = id;
  }
  UnSuspendModal(id: any) {
    this.display = 'block';
    this.display = 'flex';
    this.model3 = true;
    this.model1 = false;
    this.model2 = false;
    this.userId = id;
  }
  onCloseHandled() {
    this.display = 'none';
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    } 

    for(let i=0;i<this.subscriptions.length;i++)
    this.subscriptions[i].unsubscribe();
  }


}
